var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_setup.isErrored)?_c(_setup.asyncComponent,_vm._b({tag:"component"},'component',_setup.componentProps,false)):_c('ComposedPlaceholderErrorWithButton',_vm._b({attrs:{"errorProps":{
            description: _vm.$t('something_went_wrong_try_again')
        },"buttonText":_vm.$t('retry')},on:{"button-click":_setup.retryInternal}},'ComposedPlaceholderErrorWithButton',_setup.errorWithButtonProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }